const { aboutData } = await import('./data');

const ADD_POST = 'ADD-POST';

let initialState = {
  aboutData,
};

const profileReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_POST:
      return {};
    default:
      return state;
  }
};

export const addPostActionCreator = () => ({ type: ADD_POST });

export default profileReducer;
